import React, { useState, useEffect, useRef } from 'react';
import GymNavbar from '../gymhomepage/components/navbar'
import GymHerosection from '../gymhomepage/components/herosection'
import PlanCard from '../gymhomepage/components/PlanCard'
import GymContact from '../gymhomepage/components/ContactForm'
import GymFooter from '../gymhomepage/components/footer.js'
import { createGymHomePage, getGBussinessInfo, getGymAddonsList, getGymHomePage, getGymPlansList } from '../services/apiServices';
import LeftPane from '../components/LeftPane';
import Header from '../components/Header';
import {
    MDBContainer,
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarToggler,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBNavbarLink,
    MDBCollapse,
    MDBIcon
} from 'mdb-react-ui-kit';
import BrandLogo from "../components/images/Easy-MembrLogo.png";
import { defaultPageInfo } from '../utils/defaultPageInfo';
import { Button } from 'reactstrap';
import { useLocation, useNavigate } from "react-router";
import PreviewNavbar from '../gymhomepage/components/previewNavbar';
import { useAccess } from '../context/AccessContext';

function GymTemplate({ from }) {
    // const [pageData, setPageData] = useState({
    //     _id: -1,
    //     herosections: [
    //         {
    //             id: 'hero1',
    //             type: 'hero',
    //             title: "Transform Your Body Elevate Your Life",
    //             subtitle: "FIT YOUR BODY",
    //             description: "Unlock your full potential with a stronger, healthier body and a focused mind.",
    //             backgroundcolor: "#ffffff",
    //             heroimage: "",
    //             layout: "image-left",
    //             isactive: true,
    //             order: 0,
    //             layoutorder: ['content', 'image',],
    //             contentposition: 'left',
    //             imageposition: 'right',
    //             button: {
    //                 enabled: true,
    //                 text: "Join Now",
    //                 url: "#",
    //                 color: "#ffffff",
    //                 bgcolor: "#007bff",
    //                 bordercolor: "transparent",
    //                 hoverbgcolor: "#0069d9",
    //                 hovercolor: "#ffffff",
    //                 size: "md",
    //                 borderradius: "4px"
    //             }
    //         }
    //     ],
    //     plans: {
    //         id: 'plans1',
    //         type: 'plans',
    //         title: "Membership Plans",
    //         subtitle: "Get plans",
    //         isactive: true,
    //         backgroundcolor: "#ffffff",
    //         items: [
    //             {
    //                 id: 'plan1',
    //                 name: "Basic",
    //                 planid: "",
    //                 features: ["Access to gym", "Standard equipment"],
    //                 themecolor: " #f88b4f",
    //                 btntext: "Choose Plan",

    //             },
    //             {
    //                 id: 'plan2',
    //                 name: "Premium",
    //                 planid: "",
    //                 features: ["All Basic features", "Premium equipment", "Personal trainer"],
    //                 themecolor: "#007bff",
    //                 btntext: "Choose Plan",
    //             }
    //         ]
    //     },
    //     contact: {
    //         id: 'contact1',
    //         type: 'contact',
    //         subtitle: "Get in touch",
    //         title: "Contact with us for more",
    //         description: "We'd love to hear from you!\nLet's get in touch",
    //         image: "",
    //         order: 0,
    //         contentposition: 'right',
    //         imageposition: 'left',
    //         layout: "image-left",
    //         backgroundcolor: "#f4efff",
    //         layoutorder: ['image', 'content'],
    //         cardbackground: "#ffffff",
    //         isactive: true,
    //         button: {
    //             text: "Send Message",
    //             color: "#ffffff",
    //             bgcolor: "#7b5cfa",
    //             bordercolor: "transparent"
    //         }
    //     },
    //     footer: {
    //         id: 'footer1',
    //         type: 'footer',
    //         content: "© 2025 Easymenbr. All rights reserved.",
    //         isactive: true,
    //         backgroundcolor: "#2c3e50",
    //         color: "#ffffff",
    //         links: [
    //             {
    //                 label: 'facebook',
    //                 check: true,
    //                 url: 'https://www.facebook.com/'
    //             },
    //             {
    //                 label: 'twitter',
    //                 check: true,
    //                 url: 'https://twitter.com/'
    //             },
    //             {
    //                 label: 'youtube',
    //                 check: true,
    //                 url: ''
    //             },
    //             {
    //                 label: 'whatsapp',
    //                 check: false,
    //                 url: ''
    //             },
    //             {
    //                 label: 'instagram',
    //                 check: false,
    //                 url: 'https://www.instagram.com/crag.studio/'
    //             },
    //             {
    //                 label: 'linkedin',
    //                 check: false,
    //                 url: ''
    //             }
    //         ]
    //     }
    // });
    const [pageData, setPageData] = useState(defaultPageInfo);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGymHomePage(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (response && response !== "false") {
                    const tempData = await response.json();
                    console.log(tempData, 'tempData')

                    setPageData(tempData);
                }
            }
        }
        fetchData();
    }, []);

    const [membership, setMembership] = useState([])
    console.log("membershipgymtemplate", membership)
    const [bussinessInfo, setBusinessinfo] = useState(null)
    const [openNav, setOpenNav] = useState(false);

    useEffect(() => {
        fetchPlansAndAddons();

        async function fetchPlansAndAddons() {
            const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo"));
            if (!userInfo) return;

            let mergedMembership = [];


            // Fetch Plans
            const plansResponse = await getGymPlansList(userInfo.gymid);
            if (plansResponse && plansResponse !== "false") {
                const plansData = await plansResponse.json();


                console.log("tempplansData", plansData)
                const formattedPlans = plansData.flatMap(plan => {

                    if (Array.isArray(plan.subplans) && plan.subplans.length > 0) {
                        return plan.subplans.map(subplan => ({
                            ...subplan,
                            type: "plan",
                            displayName: `${plan?.name}-${subplan?.name}`
                        }));
                    }

                    return [{
                        ...plan,
                        type: "plan",
                        displayName: plan?.name
                    }];
                });

                mergedMembership = [...mergedMembership, ...formattedPlans];
            }


            // Fetch Addons
            const addonsResponse = await getGymAddonsList(userInfo.gymid);
            if (addonsResponse && addonsResponse !== "false") {
                const addonsData = await addonsResponse.json();
                const enabledAddons = addonsData
                    .filter(addon => addon.enable === true)
                    .map(addon => ({ ...addon, type: "addons", displayName: addon.name }));
                mergedMembership = [...mergedMembership, ...enabledAddons];
            }

            setMembership(mergedMembership);
        }
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            if (localStorage.getItem("loggedUserInfo")) {
                const response = await getGBussinessInfo(
                    JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
                );
                if (!response || response === "false") {
                    return;
                }
                const recinfo = await response.json();
                if (recinfo) {
                    console.log(recinfo, 'recinfo');

                    setBusinessinfo(recinfo)
                }
            }
        }

        fetchData();
    }, []);

    const isHiden = {
        plans: pageData?.plans?.isactive ? false : true,
        contact: pageData?.contact?.isactive ? false : true
    }

    const handleEdit = () => {
        navigate("/editgymhome");
    }

    const { handlePageAccess } = useAccess();
    const roleAccess = handlePageAccess("yourwebsite")

    return (
        <div>
            {from !== "edit" && <LeftPane isactive="15" />}
            {from !== "edit" && <Header />}

            <div className={`gym-main ${from !== "edit" ? "rightContent gymtemplte_content" : ""}`}>




                {from !== "edit" && roleAccess?.editwebsite !== 2 &&
                    <div className='gymhead'>
                        <h5 className='m-0'>WebSite Template</h5>
                        <Button onClick={() => { handleEdit() }}>
                            Edit your website
                        </Button>
                    </div>
                }




                {/* <MDBNavbar expand='lg' light bgColor='light' sticky style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
                    <MDBContainer fluid className='px-4'>
                        <MDBNavbarBrand href='#' className='brand-logo'>
                            <img src={BrandLogo} alt="Brand Logo"></img>
                        </MDBNavbarBrand>
                        <MDBNavbarToggler
                            type='button'
                            aria-expanded='false'
                            aria-label='Toggle navigation'
                            onClick={() => setOpenNav(!openNav)}
                        >
                            <MDBIcon icon='bars' fas />
                        </MDBNavbarToggler>
                        <MDBCollapse navbar open={openNav}>
                            <MDBNavbarNav>
                                <MDBNavbarItem className='navbar-list'>
                                    <MDBNavbarLink
                                        active
                                        aria-current='page'
                                        href='#'
                                    >
                                        Home
                                    </MDBNavbarLink>
                                </MDBNavbarItem>
                                {!(isHiden.plans) && <MDBNavbarItem className='navbar-list'>
                                    <MDBNavbarLink

                                        href='#'
                                    >
                                        Plans
                                    </MDBNavbarLink>
                                </MDBNavbarItem>}
                                {!(isHiden.contact) && <MDBNavbarItem className='navbar-list'>
                                    <MDBNavbarLink
                                        href='#'
                                    >
                                        Contact
                                    </MDBNavbarLink>
                                </MDBNavbarItem>}
                                <MDBNavbarItem className='navbar-list d-flex'>
                                    <button className="btnn btn-1 hover-filled-slide-down">
                                        <span>Login</span>
                                    </button>
                                </MDBNavbarItem>
                            </MDBNavbarNav>
                        </MDBCollapse>
                    </MDBContainer>
                </MDBNavbar> */}
                <PreviewNavbar isHiden={isHiden} logourl={bussinessInfo?.logourl} />
                <div>
                    <GymHerosection pageData={pageData} />

                    {pageData?.plans?.isactive ? <PlanCard planData={pageData?.plans} membership={membership} /> : <></>}

                    {pageData?.contact?.isactive ? <GymContact contactData={pageData?.contact} bussinessInfo={bussinessInfo} /> : <></>}

                    {pageData?.footer?.isactive ? <GymFooter footerData={pageData?.footer} bussinessInfo={bussinessInfo} /> : <></>}
                </div>
            </div>
        </div >
    )
}

export default GymTemplate
